import React, { useState } from 'react';

const getVariantClasses = (index) => {
  const baseClasses = "text-sm font-bold px-2 py-1 rounded-md";
  let colorClasses = "";

  switch (index % 3) {
    case 0: // Variant 1
      colorClasses = "bg-green-100 text-green-800 dark:bg-green-800/50 dark:text-green-200";
      break;
    case 1: // Variant 2
      colorClasses = "bg-yellow-100 text-yellow-800 dark:bg-yellow-800/50 dark:text-yellow-200";
      break;
    case 2: // Variant 3
      colorClasses = "bg-purple-100 text-purple-800 dark:bg-purple-800/50 dark:text-purple-200";
      break;
    default:
      colorClasses = "bg-blue-100 text-blue-800 dark:bg-blue-800/50 dark:text-blue-200";
  }
  return `${baseClasses} ${colorClasses}`;
};

const VariantCard = ({ variant, index }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  const formatPostForCopy = (title, content) => {
    return `title: ${title}\ncontent: ${content}`;
  };

  return (
    <div className="bg-[var(--background-color-card)] p-6 rounded-xl border border-[var(--color-border-subtle)] shadow-sm" data-testid="variantCard-container">
      <div className="flex items-start justify-between mb-4">
        <div>
          <span className={getVariantClasses(index)} data-testid="variantCard-variantLabel">
            variant {index + 1}
          </span>
        </div>
      </div>
      <div className="relative">
        <div className={`prose prose-sm dark:prose-invert max-w-none text-[var(--color-text-secondary)] leading-relaxed pr-8 ${!isExpanded ? 'line-clamp-4' : ''}`}>
          <p><strong>Title:</strong> {variant.title}</p>
          <p><strong>Content:</strong></p>
          <p className="text-text-light-secondary dark:text-text-dark-secondary leading-relaxed">
            {variant.content}
          </p>
          <p className="text-sm text-text-light-secondary dark:text-text-dark-secondary italic border-l-2 border-blue-300 pl-3 my-3">
            <strong className="font-semibold">Reasoning:</strong> {variant.reasoning}
          </p>
        </div>
        <button onClick={toggleExpansion} className="absolute bottom-0 right-0 bg-transparent !bg-transparent text-[var(--color-primary-accent)] hover:bg-transparent !hover:bg-transparent transition-none flex-shrink-0 p-1 min-w-[unset] min-h-[unset] border-none outline-none" data-testid="variantCard-expandCollapseButton">
          <span className="material-symbols-outlined text-xl">
            {isExpanded ? 'expand_less' : 'expand_more'}
          </span>
        </button>
      </div>
      <div className="mt-4">
        <button onClick={() => copyToClipboard(formatPostForCopy(variant.title, variant.content))} className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="variantCard-copyButton">
          <span className="material-symbols-outlined text-base">content_copy</span>
          Copy
        </button>
      </div>
    </div>
  );
};

export default VariantCard;
